<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
      <c-table
        ref="deptTable"
        title="부서 기본유해인자 목록"
        tableId="deptTable"
        :columns="grid.columns"
        :data="grid.data"
        :columnSetting="false"
        selection="multiple"
        :isExcelDown="false"
        rowKey="hazardCd"
        :filtering="false"
        :usePaging="false"
        :hideBottom="true"
        gridHeight="400px"
      >
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn label="추가" v-if="editable" icon="add" @btnClicked="addrow" />
            <c-btn label="삭제" v-if="editable && grid.data.length > 0" icon="remove" @btnClicked="removeRow" />
          </q-btn-group>
        </template>
      </c-table>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
      <c-table
        ref="userTable"
        title="부서 기본 적용대상자"
        tableId="userTable"
        :columns="grid2.columns"
        :data="grid2.data"
        :columnSetting="false"
        :isExcelDown="false"
        :filtering="false"
        :usePaging="false"
        :hideBottom="true"
        gridHeight="400px"
      >
      </c-table>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
      <c-card title="부서별 공정구분" class="cardClassDetailForm" topClass="topcolor-orange">
        <template slot="card-detail">
          <div class="col-12" style="margin-top: -15px !important">
            <c-table
              topBorderClass="topcolor-orange"
              ref="grid3"
              title="공정구분"
              tableId="grid3"
              :columns="grid3.columns"
              :data="grid3.data"
              :columnSetting="false"
              selection="single"
              :isExcelDown="false"
              rowKey="saiHazardDeptTypeId"
              :filtering="false"
              :usePaging="false"
              :hideBottom="true"
              :isFullScreen="false"
              :gridHeight="sTableHeight"
              @rowClick="rowClick"
            >
              <template slot="table-button">
                <q-btn-group outline >
                  <c-btn label="" v-if="editable" icon="add" @btnClicked="addRow3" />
                  <c-btn label="" v-if="editable && grid3.data.length > 0" icon="remove" @btnClicked="removeRow3" />
                </q-btn-group>
              </template>
            </c-table>
          </div>
        </template>
      </c-card>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10">
      <c-card title="부서 공정구분별 유해인자/적용대상자" class="cardClassDetailForm" topClass="topcolor-orange">
        <template slot="card-detail">
          <div class="col-8" style="margin-top: -15px !important">
            <c-table
              topBorderClass="topcolor-orange"
              ref="grid4"
              title="유해인자"
              tableId="grid4"
              :columns="grid4.columns"
              :data="grid4.data"
              :columnSetting="false"
              selection="multiple"
              :isExcelDown="false"
              rowKey="hazardCd"
              :filtering="false"
              :usePaging="false"
              :hideBottom="true"
              :isFullScreen="false"
              :gridHeight="sTableHeight"
            >
              <template slot="table-button">
                <q-btn-group outline >
                  <c-btn label="" v-if="editable && selectedType.saiHazardDeptTypeId" icon="add" @btnClicked="addRow4" />
                  <c-btn label="" v-if="editable && grid4.data.length > 0" icon="remove" @btnClicked="removeRow4" />
                </q-btn-group>
              </template>
              <template slot="suffixTitle">
                <q-chip
                  v-show="selectedType.saiHazardDeptTypeName"
                  color="orange-6"
                  text-color="white"
                  style="margin-bottom:0px !important;">
                  {{selectedType.saiHazardDeptTypeName}}
                </q-chip>
              </template>
            </c-table>
          </div>
          <div class="col-4" style="margin-top: -15px !important">
            <c-table
              topBorderClass="topcolor-orange"
              ref="grid5"
              title="적용대상자"
              tableId="grid5"
              :columns="grid5.columns"
              :data="grid5.data"
              :columnSetting="false"
              selection="multiple"
              :isExcelDown="false"
              rowKey="userId"
              :filtering="false"
              :usePaging="false"
              :hideBottom="true"
              :isFullScreen="false"
              :gridHeight="sTableHeight"
            >
              <template slot="table-button">
                <q-btn-group outline >
                  <c-btn label="" v-if="editable && selectedType.saiHazardDeptTypeId" icon="add" @btnClicked="addRow5" />
                  <c-btn label="" v-if="editable && grid5.data.length > 0" icon="remove" @btnClicked="removeRow5" />
                </q-btn-group>
              </template>
              <template slot="suffixTitle">
                <q-chip
                  v-show="selectedType.saiHazardDeptTypeName"
                  color="orange-6"
                  text-color="white"
                  style="margin-bottom:0px !important;">
                  {{selectedType.saiHazardDeptTypeName}}
                </q-chip>
              </template>
            </c-table>
          </div>
        </template>
      </c-card>
    </div>
    <q-dialog v-model="prompt" persistent>
      <q-card style="min-width: 350px">
        <q-card-section>
          <div class="text-h6">부서별 공정구분 명</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <q-input dense v-model="saiHazardDeptTypeName" autofocus @keyup.enter="setMst" />
        </q-card-section>

        <q-card-actions align="right" class="text-primary">
          <q-btn flat label="취소" @click="cancelMst" />
          <q-btn flat label="추가" @click="setMst" />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'dept-harmful-factors-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        deptCd: '',
      }),
    },
  },
  data() {
    return {
      prompt: false,
      selectedType: {},
      mappingType: 'POST',
      saveUrl: '',
      deleteUrl: '',
      revlistUrl: '',
      chemName: '',
      checkUrl: '',
      subListUrl: '',
      subSaveUrl: '',
      subDeleteUrl: '',
      userListUrl: '',
      list3Url: '',
      list4Url: '',
      list5Url: '',
      save3Url: '',
      save4Url: '',
      save5Url: '',
      delete3Url: '',
      delete4Url: '',
      delete5Url: '',
      editable: true,
      isSave: false,
      isdelete: false,
      isRevision: false,
      updateMode: false,
      sTableHeight: '',
      saiHazardDeptTypeName: '',
      data: {
        hazardCd: '',
        hazardClassFstCd: null,
        hazardClassSecCd: null,
        hazardName: '',
        mdmChemMaterialId: '',
        useFlag: 'Y',
        mttrid: '',
        casNo: '',
        workEnvFlag: 'Y',
        speHealthFlag: 'Y',
        workMeasCycleCd: null,
        factorMeasCycleCd: null,
        regUserId: '',
        chgUserId: '',

        deptList: [],
      },
      chemList: [],
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      workFlagItems: [
        { code: 'Y', codeName: '관련' },
        { code: 'N', codeName: '미관련' },
      ],
      occSecItems: [],
      grid: {
        columns: [
          {
            name: 'hazardClassFstName',
            field: 'hazardClassFstName',
            label: '유해인자 대분류',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'hazardClassSecName',
            field: 'hazardClassSecName',
            label: '유해인자 중분류',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'hazardName',
            field: 'hazardName',
            label: '유해인자명',
            align: 'left',
            style: 'width:200px',
            sortable: true,
          },
        ],
        data: [],
      },
      grid2: {
        columns: [
          {
            name: 'userName',
            field: 'userName',
            label: '사용자',
            align: 'center',
            sortable: true,
          },
          {
            name: 'jobName',
            field: 'jobName',
            label: '직책',
            align: 'center',
            sortable: true,
          },
        ],
        data: [],
      },
      grid3: {
        columns: [
          {
            name: 'saiHazardDeptTypeName',
            field: 'saiHazardDeptTypeName',
            label: '구분명',
            align: 'center',
            sortable: true,
          },
        ],
        data: [],
      },
      grid4: {
        columns: [
          {
            name: 'hazardClassFstName',
            field: 'hazardClassFstName',
            label: '유해인자 대분류',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'hazardClassSecName',
            field: 'hazardClassSecName',
            label: '유해인자 중분류',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'hazardName',
            field: 'hazardName',
            label: '유해인자명',
            align: 'left',
            style: 'width:200px',
            sortable: true,
          },
        ],
        data: [],
      },
      grid5: {
        columns: [
          {
            name: 'userName',
            field: 'userName',
            label: '사용자',
            align: 'center',
            sortable: true,
          },
          {
            name: 'jobName',
            field: 'jobName',
            label: '직책',
            align: 'center',
            sortable: true,
          },
        ],
        data: [],
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // url setting
      this.userListUrl = selectConfig.sai.hazard.dept.user.url;
      this.detailUrl = selectConfig.sai.hazard.get.dept.url;
      this.saveUrl = transactionConfig.sai.hazard.insert.dept.url;
      this.deleteUrl = transactionConfig.sai.hazard.dept.delete.url;
      
      this.list3Url= selectConfig.sai.hazard.dept.type.list.url;
      this.list4Url= selectConfig.sai.hazard.dept.type.factor.url;
      this.list5Url= selectConfig.sai.hazard.dept.type.user.url;
      this.save3Url= transactionConfig.sai.hazard.type.insert.url;
      this.save4Url= transactionConfig.sai.hazard.type.factor.insert.url;
      this.save5Url= transactionConfig.sai.hazard.type.user.insert.url;
      this.delete3Url= transactionConfig.sai.hazard.type.delete.url;
      this.delete4Url= transactionConfig.sai.hazard.type.factor.delete.url;
      this.delete5Url= transactionConfig.sai.hazard.type.user.delete.url;

      this.sTableHeight = (window.innerHeight - 580) + 'px';

      this.getDetail();
      this.getDefaultUser();
      this.getTypeList();
    },
    getDetail() {
      if (this.popupParam.deptCd) {
        this.$http.url = this.$format(this.detailUrl, this.popupParam.deptCd);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.grid.data = this.$_.clone(_result.data);
        },);
      }
    },
    getDefaultUser() {
      if (this.popupParam.deptCd) {
        this.$http.url = this.userListUrl;
        this.$http.param = {deptCd: this.popupParam.deptCd};
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.grid2.data = _result.data;
        },);
      }
    },
    getTypeList() {
      if (this.popupParam.deptCd) {
        this.$http.url = this.list3Url;
        this.$http.param = {deptCd: this.popupParam.deptCd};
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.grid3.data = _result.data;
          this.grid4.data = [];
          this.grid5.data = [];
          this.selectedType = {};
          this.$refs['grid3'].$refs['compo-table'].clearSelection();
        },);
      }
    },
    getTypeFactors(row) {
      if (row) {
        this.$http.url = this.list4Url;
        this.$http.param = {saiHazardDeptTypeId: row.saiHazardDeptTypeId};
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.grid4.data = _result.data;
        },);
      }
    },
    getTypeUsers(row) {
      if (row) {
        this.$http.url = this.list5Url;
        this.$http.param = {saiHazardDeptTypeId: row.saiHazardDeptTypeId};
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.grid5.data = _result.data;
        },);
      }
    },
    rowClick(row) {
      this.selectedType = row;
      this.getTypeFactors(row);
      this.getTypeUsers(row);
    },
    addrow() {
      this.popupOptions.title = '유해인자 추가';
      this.popupOptions.param = {
        deptCd: this.popupParam.deptCd,
        type: 'multiple',
        disabled: false,
      }
      this.popupOptions.target = () => import(`${'@/pages/sai/wmr/harmfulFactorsPop.vue'}`);
      this.popupOptions.width = '80%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeDept;
    },
    closeDept(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        let saveData = [];
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.grid.data, { hazardCd: item.hazardCd }) === -1) {
            saveData.push({
              hazardCd: item.hazardCd,
              hazardName: item.hazardName,
              deptCd: this.popupParam.deptCd,
              editFlag: 'C',
            })
          }
        })
        if (saveData.length > 0) {
          this.$http.url = this.saveUrl;
          this.$http.type = 'POST';
          this.$http.param = saveData;
          this.$http.request(() => {
            this.getDetail();
            window.getApp.$emit('APP_REQUEST_SUCCESS');
          });
        }
      }
    },
    removeRow() {
      let selectData = this.$refs['deptTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '삭제하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'warning', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.deleteUrl;
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData)
            }
            this.$http.request(() => {
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              this.$set(this.$refs['deptTable'], 'selected', [])
              this.getDetail();
            })
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    addRow3() {
      this.prompt = true;
    },
    cancelMst() {
      this.saiHazardDeptTypeName = '';
      this.prompt = false;
    },
    setMst() {
      this.prompt = false;
      this.$http.url = this.save3Url;
      this.$http.type = 'POST';
      this.$http.param = [{
        deptCd: this.popupParam.deptCd,  // 부서 코드
        saiHazardDeptTypeName: this.saiHazardDeptTypeName,  // 부서별 구분명
        editFlag: 'C',
      }];
      this.$http.request(() => {
        this.getTypeList();
        window.getApp.$emit('APP_REQUEST_SUCCESS');
        this.saiHazardDeptTypeName = '';
      });
    },
    removeRow3() {
      let selectData = this.$refs['grid3'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '삭제하시겠습니까?',
          type: 'warning', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.delete3Url;
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData)
            };
            this.$http.request(() => {
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              this.$_.forEach(selectData, item => {
                this.grid3.data = this.$_.reject(this.grid3.data, item);
              })
              this.grid4.data = [];
              this.grid5.data = [];
              this.selectedType = {};
              this.$refs['grid3'].$refs['compo-table'].clearSelection();
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    addRow4() {
      this.popupOptions.title = '유해인자 추가';
      this.popupOptions.param = {
        deptCd: this.popupParam.deptCd,
        type: 'multiple',
        disabled: false,
      }
      this.popupOptions.target = () => import(`${'@/pages/sai/wmr/harmfulFactorsPop.vue'}`);
      this.popupOptions.width = '80%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeDept2;
    },
    closeDept2(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        let saveData = [];
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.grid.data, { hazardCd: item.hazardCd }) === -1) {
            if (this.$_.findIndex(this.grid4.data, { hazardCd: item.hazardCd }) === -1) {
              saveData.push({
                saiHazardDeptTypeId: this.selectedType.saiHazardDeptTypeId,  // 부서별 구분 일련번호
                hazardCd: item.hazardCd,  // 유해인자 코드
                editFlag: 'C',
              })
            }
          }
        })
        if (saveData.length > 0) {
          this.$http.url = this.save4Url;
          this.$http.type = 'POST';
          this.$http.param = saveData;
          this.$http.request(() => {
            this.getTypeFactors({saiHazardDeptTypeId:this.selectedType.saiHazardDeptTypeId});
            window.getApp.$emit('APP_REQUEST_SUCCESS');
          });
        }
      }
    },
    removeRow4() {
      let selectData = this.$refs['grid4'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '삭제하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'warning', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.delete4Url;
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData)
            }
            this.$http.request(() => {
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              this.$_.forEach(selectData, item => {
                this.grid4.data = this.$_.reject(this.grid4.data, item);
              })
              this.$refs['grid4'].$refs['compo-table'].clearSelection();
            })
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    addRow5() {
      this.popupOptions.title = '적용대상자 검색'; // 적용대상자 검색
      this.popupOptions.param = {
        type: 'multiple',
        deptCd: this.popupParam.deptCd,
      };
      this.popupOptions.target = () => import(`${'@/pages/common/user/userPop.vue'}`);
      this.popupOptions.width = '50%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeUserPopup;
    },
    closeUserPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        let saveData = [];
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.grid5.data, { userId: item.userId }) === -1) {
            saveData.push({
              saiHazardDeptTypeId: this.selectedType.saiHazardDeptTypeId,  // 부서별 구분 일련번호
              userId: item.userId,  // 사용자아이디
              editFlag: 'C',
            })
          }
        })
        if (saveData.length > 0) {
          this.$http.url = this.save5Url;
          this.$http.type = 'POST';
          this.$http.param = saveData;
          this.$http.request(() => {
            this.getTypeUsers({saiHazardDeptTypeId:this.selectedType.saiHazardDeptTypeId});
            this.getDefaultUser();
            window.getApp.$emit('APP_REQUEST_SUCCESS');
          });
        }
      }
    },
    removeRow5() {
      let selectData = this.$refs['grid5'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '삭제하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'warning', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.delete5Url;
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData)
            }
            this.$http.request(() => {
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              this.$_.forEach(selectData, item => {
                this.grid5.data = this.$_.reject(this.grid5.data, item);
              })
              this.getDefaultUser();
              this.$refs['grid4'].$refs['compo-table'].clearSelection();
            })
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    }
  }
};
</script>
